import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Block from '../../../../../components/Block';
import Text from '../../../../../components/Text';
import RemoveSingleFile from '../trash/singleFile';
import Warning from '../warning/warning';
import FileDownload from '../../../../../../core/helpers/FileDownload';

const Content = styled.div`
  width: 100%;
  display: flex;
`;

const ContentButton = styled.div`
  display: flex;
  justify-content: center;
  min-height: 48px;
`;

const ButtonRemove = styled.button`
  &:focus cc-icon {
    color: #4318cd;
    // background-color: red;
  }
  &:focus * {
    color: white;
    // background-color: red;
  }
`;

interface IProps {
  dataFile: any;
  formatAllowed: boolean;
  handleRemoveFormatError: () => void;
  handleRemoveSingleFile: (options: any) => void;
  index: number;
  labelName: string;
  labelSize: number;
  maxFileSize: number;
}
const ItemFile = ({
  labelName,
  labelSize,
  maxFileSize,
  dataFile,
  index,
  handleRemoveSingleFile,
  formatAllowed,
  // eslint-disable-next-line
  handleRemoveFormatError
}: IProps) => {
  const [file, setFile] = useState<File>();
  const [fileNameOptimized, setFileNameOptimized] = useState('');
  const bytesToMegaBytes = (bytes: any, digits: any, roundTo: any) =>
    roundTo ? (bytes / (1024 * 1024)).toFixed(digits) : bytes / (1024 * 1024);
  const getExt = (filename: any) => {
    const ext = filename.split('.').pop();
    if (ext === filename) return '';
    return ext;
  };
  const fileSizeMB = Number(bytesToMegaBytes(labelSize, 2, true)) > maxFileSize;

  useEffect(() => {
    if (labelName?.length > 14) {
      const parts = labelName.split('.');
      parts.pop();
      setFileNameOptimized(
        `${parts.join('.').substring(0, 14)}...${getExt(labelName)}`
      );
    } else setFileNameOptimized(labelName);
  });

  const downloadHandler = () => {
    setFile(dataFile);
  };

  const resetHandler = () => {
    setFile(undefined);
  };

  return (
    <>
      <FileDownload file={file} finish={() => resetHandler()} />
      <Content data-testid="button-ds-file-upload">
        <Block
          style={
            fileSizeMB ? { border: '1px solid red', borderRadius: '5px' } : {}
          }
          customized
          borderRadius="4px"
          border={!formatAllowed ? '1px solid #E8212B' : '1px solid #fff'}
          alignContent="center"
          justifyContent="center"
          flexDirection="row"
          margin={index !== 0 ? '8px 0px 0px' : '0px'}
        >
          <Block
            customized
            backgroundColor="#ECF4F9"
            minHeight="48px"
            borderRadius="4px"
            alignContent="center"
            justifyContent="center"
            alignItems="flex-start"
            flexDirection="column"
          >
            <Block
              customized
              alignItems="center"
              display="flex"
              flexDirection="row"
              padding="4px 8px"
            >
              <Block
                customized
                flexDirection="column"
                alignContent="center"
                justifyContent="space-between"
                alignItems="center"
                maxWidth="calc(100% - 40px)"
                className=""
              >
                <Block
                  customized
                  flexDirection="row"
                  alignContent="center"
                  justifyContent="flex-start"
                  alignItems="center"
                  className=""
                >
                  <Text fontSize="14px" lineHeight="16px" fontWeight="700">
                    {fileNameOptimized}
                  </Text>
                </Block>
                <Block
                  customized
                  flexDirection="row"
                  alignContent="center"
                  justifyContent="flex-start"
                  alignItems="center"
                  className=""
                >
                  <Text
                    color="#4F6168"
                    fontSize="12px"
                    lineHeight="20px"
                    fontWeight="400"
                  >
                    {`${bytesToMegaBytes(labelSize, 2, true)}MB`}
                  </Text>
                </Block>
              </Block>
              <ButtonRemove>
                <RemoveSingleFile
                  handleRemoveSingleFile={() => {
                    handleRemoveSingleFile(dataFile);
                  }}
                />
              </ButtonRemove>
            </Block>
            {!formatAllowed ? (
              <Block customized display="flex" flexDirection="row">
                <Warning message="¡Oh no! Este archivo no es compatible." />
              </Block>
            ) : (
              <></>
            )}
          </Block>
        </Block>
        <ContentButton>
          <ButtonRemove>
            <RemoveSingleFile
              iconName="download"
              handleRemoveSingleFile={() => downloadHandler()}
            />
          </ButtonRemove>
        </ContentButton>
      </Content>
    </>
  );
};

export default ItemFile;
